import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { UserProfile } from '../../../core/models/user/user-profile';
import { AccountService } from '../../../core/services/api/account.service';
import { TickerCode } from '../../../core/models/mysec/ticker-code';
import { BusinessesService } from 'src/app/core/services/api/mysec/businesses.service';

@Component({
    selector: 'app-mysec-settings',
    templateUrl: './mysec-settings.component.html',
    styleUrls: ['./mysec-settings.component.scss'],
    standalone: false
})
export class MysecSettingsComponent implements OnInit {
  profile: UserProfile;
  isLoading = true;
  tickerCodes: TickerCode[];

  constructor(
    private accountService: AccountService,
    private businessesService: BusinessesService,
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.accountService.profile(false).subscribe({
      next: (data) => {
        this.profile = data;

        if (data?.isMYsecAvailable) {
          this.getTickerCodes();
        } else {
          this.tickerCodes = [];
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  getTickerCodes() {
    this.businessesService
      .getTickerCodes()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((data) => {
        this.tickerCodes = data;
      });
  }
}
